import React from "react";

const StatusForDrawer = ({
  text,
  width,
  height,
  weight,
  size,
  color,
  textColor,
  icon,
  onClick,
  borderRadius,
  border,
  disabled,
  statusName,
  other,
}) => {
  const getStatusClasses = () => {
    switch (statusName) {
      case "Released":
      case "Final Report":
        return "bg-green-50 text-green-700 ring-green-600/20 px-2";
      case "Pending":
      case "Sponsor Draft Report":
      case "Provider Draft Report":
        return "bg-yellow-50 text-yellow-800 ring-yellow-600/20 px-2";
      case "Rejected":
        return "bg-red-50 text-red-700 ring-red-600/10";
      case "Report Anonymized":
      case "Published":
        return "bg-purple-50 text-purple-700 ring-purple-700/10 px-2";
      case "Upcoming":
      case "CAPA Response Report":
        return "bg-blue-50 text-blue-700 ring-blue-700/10 px-2";
      default:
        return "bg-gray-50 text-gray-700 ring-gray-600/20 px-2";
    }
  };

  return (
    <div className="flex flex-shrink-0 flex-grow-0 items-center justify-center gap-1 ">
      <div
        className={`rounded-md px-0 mr-[-2px] py-1 text-xs font-medium ring-1 ring-inset ${getStatusClasses()} ${border} ${width} ${height} ${weight} ${size} ${borderRadius}`}
      >
        {icon && <div className="mr-1">{icon}</div>}
        <span>
          {statusName === "Sponsor Draft Report"
            ? "Sponsor Draft"
            : statusName === "Provider Draft Report"
            ? "Provider Draft"
            : statusName === "CAPA Response Report"
            ? "Observation report"
            : statusName === "Final Report"
            ? "Final"
            : statusName === "Report Anonymized"
            ? "Anonymized"
            : statusName}
        </span>
      </div>
      {other && (
        <span
          className={`rounded-md px-0 mr-[-2px] py-1 text-xs font-medium ring-1 ring-inset ${getStatusClasses()} ${border} ${width} ${height} ${weight} ${size} ${borderRadius}`}
        >
          {" "}
          {<div>{other}</div>}
        </span>
      )}
    </div>
  );
};

export default StatusForDrawer;
